<template>
	<div>
		<tool-new-level
			@view-hierarchy="viewHierarchyFather"
			@return-page="returnPage"
			:disabled-view="treeData.length !== 0"/>
		<div class="tree-table-container">
			<div class="tree-table-header">
				<h3 class="tree-table-header-title">Nombre de la herramienta - configuración</h3>
				<div class="tree-table-header-search">
					<div class="search-input">
						<input
							:style="`color:${$appColors.info}`"
							type="text"
							v-model="search"
							@keyup.enter="searchRows"
							@keyup.esc="searchRows"
						/>
						<img
							:src="`${$imageUrl}/magnifying-glass.svg`"
							alt="Buscador"
							height="20"
							width="20"
						/>
					</div>
					<div>ícono</div>
				</div>
			</div>
			<tree-tool-table
				:tree-data="treeData"
				@delete-item="loadParamCode"
			></tree-tool-table>
		</div>
		<router-view name="newLevel"></router-view>
		<router-view name="newType"></router-view>
		<v-dialog
			v-model="viewDataHierarchy"
			persistent
			max-width="800">
			<p-card class="tw-p-none overflow-hidden">
				<p-header-dialog :negative-margin="false" @closeClicked="closeModal()"></p-header-dialog>
				<div class="tree-table-container-view">
					<tree-tool-table-view
						:tree-data="hierarchyFather"
					></tree-tool-table-view>
				</div>
				<div class="tw-flex tw-justify-center tw-py-3 tw-gap-3">
					<p-button
						type="black"
						@click="closeModal()">Cancelar</p-button>
					<p-button
						type="primary"
						@click="cloneHierarchy"
						>Clonar</p-button>
				</div>
			</p-card>
		</v-dialog>
	</div>
</template>
<script>
import toolNewLevel from '@/components/configuration/tools/tool-new-level';
import treeToolTable from '@/components/configuration/tools/tree-tool-table';
import PCard from '@/modules/shared/components/ui/Card/p-card';
import PButton from '@/modules/shared/components/ui/p-button';
import PHeaderDialog from '@/modules/shared/components/ui/dialog/p-header-dialog';
import treeToolTableView from '@/components/configuration/tools/tree-tool-table-view';
import { mapState, mapGetters, mapActions } from 'vuex';

function created() {
	this.loadParamCode();
	// this.$store.dispatch('tool/toolDetail', this.$route.params.toolCode);
	this.treeData = this.getDetails;
}

function searchRows() {}

async function loadParamCode() {
	await this.toolDetail(this.$route.params.toolCode);
}

async function loadDataFather() {
	const { toolCode } = this.$route.params;
	try {
		const { data: response } = await this.$http.get(`hierarchies/${toolCode}?father=true`);
		this.hierarchyFather = response;
	} catch (error) {
		this.showGenericError();
	}
}

function viewHierarchyFather() {
	this.viewDataHierarchy = true;
	this.loadDataFather();
}

function closeModal() {
	this.viewDataHierarchy = false;
}

async function cloneHierarchy() {
	const { toolCode } = this.$route.params;
	try {
		await this.$http.post(`hierarchies/clone/${toolCode}`);
		this.showNotification('Clonación Exitosa');
		this.closeModal();
		this.loadParamCode();
	} catch (error) {
		this.showGenericError();
	}
}

function returnPage() {
	this.goTo('tools');
}

function data() {
	return {
		search: '',
		viewDataHierarchy: false,
		hierarchyFather: [],
	};
}

export default {
	name: 'page-tool-levels',
	components: {
		toolNewLevel,
		treeToolTable,
		PCard,
		PButton,
		PHeaderDialog,
		treeToolTableView,
	},
	computed: {
		...mapState('tool', {
			treeData: state => state.details || [],
		}),
		...mapGetters('tool', [
			'getDetails',
		]),
	},
	created,
	data,
	methods: {
		searchRows,
		...mapActions('tool', [
			'toolDetail',
		]),
		loadParamCode,
		loadDataFather,
		viewHierarchyFather,
		closeModal,
		cloneHierarchy,
		returnPage,
	},
};
</script>
<style lang="scss" scoped>
.tree-table-container {
	background-color: white;

	.tree-table-header {
		align-items: center;
		display: flex;
		padding: 20px 18px;
		justify-content: space-between;
		
		.tree-table-header-title {
			color: color(info);
			font-size: size(xlarge);
			flex: 1 1 60%;
		}

		.tree-table-header-search {
			align-items: center;
			display: flex;
			flex: 1 1 40%;
		}
	}

	.search-input {
		background-color: map-get($colors, white);
		border: 1px solid map-get($colors, gray-slider);
		border-radius: 4px;
		display: inline-flex;
		height: 37px;
		max-width: 287px;
		margin: 0 10px;
		vertical-align: middle;
		width: 100%;

		input {
			font-size: 14px;
			outline: none;
			padding: 0 5px;
			width: calc(100% - 25px);
		}

		img {
			align-self: center;
		}
	}
}
.tree-table-container-view {
	background-color: white;
	overflow: auto;
	max-height: 60vh;

	.tree-table-header {
		align-items: center;
		display: flex;
		padding: 20px 18px;
		justify-content: space-between;
		
		.tree-table-header-title {
			color: color(info);
			font-size: size(xlarge);
			flex: 1 1 60%;
		}

		.tree-table-header-search {
			align-items: center;
			display: flex;
			flex: 1 1 40%;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/configuration/page-tool-levels.vue